import { CustomEventsQueryParams, fetchCustomEvents } from '@nextforce/api'
import { useQuery } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from './shared/keys'

export function useCustomEvents(params?: CustomEventsQueryParams) {
  const { server } = useServer()

  return useQuery({
    queryKey: params ? keys.list(params) : [],
    queryFn: fetch,
  })

  function fetch() {
    return fetchCustomEvents(server, params)
  }
}
